import type { ConnectionRecord } from '@studio/contract';
import { useQuery } from '@tanstack/react-query';
import { useStudioClient } from '../context';
import { parseApiError } from '../errors';

/**
 * `GET /api/connections` — list of platform OAuth connections bound to
 * the active workspace (ADR 0004 iter 40). Empty array until the user
 * binds a platform via the iter 41+ Wix install flow.
 *
 * The Connections page reads this to flip each platform card between
 * "Coming soon" (no binding + adapter not shipped), "Connect" (no
 * binding + adapter shipped, iter 44+), and "Connected" (has a
 * binding) states.
 */
export function useConnections() {
  const client = useStudioClient();
  return useQuery({
    queryKey: ['connections'],
    queryFn: async () => {
      const res = await client.api.connections.$get();
      if (!res.ok) throw await parseApiError(res);
      const data = (await res.json()) as { items: ConnectionRecord[] };
      return data;
    },
  });
}
